import { useCallback, useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { APIContext } from "../../contexts/APIContext";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { COMBINED_KEY, getGroups, selectGroup } from "./standingsGroups";

const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;
const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 40px;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const GroupButton = styled(GraphicButton)`
  min-height: 30px;
  margin-top: 0.5em;
  font-size: 0.9em;
`;
const GroupLabel = styled.div`
  width: 90%;
  margin-top: 1em;
  color: #818283;
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 800;
`;
function Tables({ game, previewGraphic }) {
  const { getStandings, getTeams } = useContext(APIContext);
  const { graphics } = useContext(GraphicsContext);
  const [standings, setStandings] = useState();
  const [selectedGroup, setSelectedGroup] = useLocalStorage(
    "rugby-table-group",
    COMBINED_KEY,
  );

  useEffect(() => {
    getStandings({}).then((data) => {
      setStandings(
        data?.standings?.find(
          (g) =>
            g?.opta_comp_ID === game?.competition?.opta_ID &&
            g?.opta_season_ID === game?.season?.opta_ID,
        ),
      );
    });
  }, [game, getStandings]);

  const groups = getGroups(standings?.data);
  const split = groups?.length > 1;
  const groupKey = split ? selectedGroup : COMBINED_KEY;

  // the standings are re-fetched on click so the graphic always goes out with
  // the latest table, not whatever was loaded when the panel opened
  const showTable = useCallback(
    async (scene, extra) => {
      let standings = (await getStandings({}))?.standings || [];
      let teams = (await getTeams({})) || [];

      standings = standings?.find(
        (g) =>
          g?.opta_comp_ID === game?.competition?.opta_ID &&
          g?.opta_season_ID === game?.season?.opta_ID,
      );
      setStandings(standings);

      let data = selectGroup(standings?.data, groupKey);

      previewGraphic(scene, {
        game: game,
        standings: { ...standings, data },
        standings_length: data?.table?.comp?.group?.team?.length,
        teams,
        ...extra,
      });
    },
    [game, groupKey, getStandings, getTeams, previewGraphic],
  );

  const push_up =
    graphics?.find((g) => g?.name === "CLOCK")?.onAir ||
    graphics?.find((g) => g?.name === "ScoreBug")?.onAir;

  return (
    <Main>
      {split && (
        <>
          <GroupLabel>Table</GroupLabel>
          <GroupButton
            green={groupKey === COMBINED_KEY}
            onClick={() => setSelectedGroup(COMBINED_KEY)}
          >
            Combined
          </GroupButton>
          {groups?.map((group) => {
            return (
              <GroupButton
                key={group?.key}
                green={groupKey === group?.key}
                onClick={() => setSelectedGroup(group?.key)}
              >
                {group?.name}
              </GroupButton>
            );
          })}
        </>
      )}
      <GraphicButton
        onClick={() => {
          showTable("FFTable");
        }}
      >
        FF Table (50)
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          showTable("SOFTable");
        }}
      >
        SOF Table (52)
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          showTable("CBTable", { top: true, push_up });
        }}
      >
        CB Top 6 Table (54)
      </GraphicButton>
      <GraphicButton
        onClick={() => {
          showTable("CBTable", { bottom: true, push_up });
        }}
      >
        CB Bottom 6 Table (55)
      </GraphicButton>
    </Main>
  );
}

export default Tables;
